export default {
  mobileBreakpoint: On.MediaQueries.width.larger,
  transitionTime: 300,
  subnavOpenClass: 'subnav-is-open',
}
